/**
 * API configuration for network requests.
 *
 * Loads base URL from environment variables (Vite-style env).
 * Falls back to default demo URLs if not provided.
 */

function getEnvVar(name: string): string | undefined {
  // Works safely in both Vite and Node environments
  interface ImportMetaEnv { env?: Record<string, string | undefined> }

  const meta = typeof import.meta !== 'undefined' ? (import.meta as ImportMetaEnv) : undefined;
  const viteEnv = meta?.env?.[name];

  const nodeEnv =
    typeof process !== 'undefined' ? process.env[name] : undefined;

  if (typeof viteEnv === 'string' && viteEnv.trim() !== '') return viteEnv;
  if (typeof nodeEnv === 'string' && nodeEnv.trim() !== '') return nodeEnv;
  return undefined;
}

// --- Safe extraction ---
const API_BASE_URL: string =
  getEnvVar('VITE_API_BASE_URL') ||
  'https://pilot.app-gateway.six3ro.com';

  // --- Default headers ---
const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
};

// --- Exported config ---
export const API_CONFIG = {
  baseURL: API_BASE_URL,
  defaultHeaders: DEFAULT_HEADERS,
  withCredentials: true,
} as const;

export const HTTP_STATUS_CONFLICT = 409;
